var PaymentMethods = (function ($, _, Backbone, PaymentMethod) {

	var PendingMethod = Backbone.Model.extend();

    var PaymentMethods = CheckoutApiCollection.extend({

		model: PaymentMethod,

		initialize: function (attrs, opts) {
			this._selected = null;
			this._init = new $.Deferred();

			var xhrMethods = this._api.getBraintreeUserPaymentMethods();

			this.listenTo(opts.order, 'sync', _.bind(function(order) {
				this._lastPaymentMethod = order.get('LastPaymentMethod'); 
				this._ourPayEnabled = order.get('OurPayEnabled');

				this.listenTo(order, 'change:OurPayEnabled', _.bind(function(m) {
					this._ourPayEnabled = m.get('OurPayEnabled');
					this._parceMethods(this.getSelected());
				}, this));

				xhrMethods
					.then(function (data) {
						/* Remove Stripe Payment Methods if Stripe is Disabled */
				        if (!_.where(order.get('AvailablePaymentOptions'), { Name: 'Stripe' }).length) {
				            data.Value.PaymentMethods = _.filter(data.Value.PaymentMethods, function(m) {
				                return m.ProviderType !== 'stripe';
				            });
				            var hasPaymentMethods = !!data.Value.PaymentMethods.length;
				            if (hasPaymentMethods && !_.where(data.Value.PaymentMethods, { Token: data.Value.LastPaidToken } ).length ) {
				                data.Value.LastPaidToken = data.Value.PaymentMethods[0].Token;
				            }
				        }
				        return data;
				    })
				    .done(_.bind(this._onLoad, this))
                    .done(this._init.resolve)
					.fail(this._init.reject);
				this._onOrderLoad(order);
			}, this));

			// opts.order.on('change:LastPaymentMethod', _.bind(this.parceMethods, this));
		},

		done: function (cb) {
			this._init.done(cb);
		},

		error: function (cb) {
			this._init.fail(cb);
		},

		getSelected: function () {
			return this._selected;
		},

		setSelected: function (token) {
			var selected = this.getSelected();
			if (selected) {
			    if (selected.get('Token') === token && selected.get('Selected')) {
					this._parceMethods(selected);
					return;
				}
				selected.set('Selected', false);
			}

			var item = this.get(token);
			if (item) {
				item.set('Selected', true);
			}

			this._parceMethods(item);
			this._select(item);
		},

		_parceMethods: function (model) {
			var displayOurPayAlone = false;
			//if (this._lastPaymentMethod === 'OurPay' && this._ourPayEnabled) {
			//    var currentToken = model && model.get('Token') || "";
			//	displayOurPayAlone =  this._lastPaidToken && this._lastPaidToken === currentToken;
			//}
            model && model.get('DisplayOurPayAlone') === undefined && model.set('DisplayOurPayAlone', displayOurPayAlone);
		},

		setData: function (data) {
			this._onLoad(data);
		},

		_select: function (method) {
			this._selected = method;
			this.trigger('selected', method);
		},

		_onLoad: function (data) {
			var t = this._getLastPaidToken(data);
			this._lastPaidToken = t;
			this.update(data.Value.PaymentMethods);
			this.setSelected(t);
		},

		_onOrderLoad: function (order) {
			if (PromiseUtil.isResolved(this._init)) {
				return;
			} else if (order.get('LastPaymentMethod')) {
				this._select(new PendingMethod({ OrderPaymentType: order.get('LastPaymentMethod') }));
			}
		},

		// NOTE: It's UI fix for case when last paid token is null.
		// NOTE: It should be not a class method because of no "this" usage, but for hack it's OK.
		_getLastPaidToken: function (data) {
			var pm = data.Value.PaymentMethods;
			var t = data.Value.LastPaidToken;
			if (pm && pm.length && !t) {
				// NOTE: Get first payment method.
				return pm[0] && pm[0].Token || null;
			}
			return t;
		}
	});

	return PaymentMethods;
})($, _, Backbone, PaymentMethod);
